import usc_1 from '../../../assets/images/usc2.png';
import usc_2 from '../../../assets/images/usc1.png';
import usc_3 from '../../../assets/images/usc6.png';
import usc_4 from '../../../assets/images/usc3.png';
import usc_5 from '../../../assets/images/usc5.png';

const slides = [
    {
        id: 1,
        image: usc_1,
    },
    {
        id: 2,
        image: usc_2,
    },
    {
        id: 3,
        image: usc_3,
    },
    {
        id: 4,
        image: usc_4,
    },
    {
        id: 5,
        image: usc_5,
    },
]

export default slides